/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_I18n_TitleInputs */

const en_landing_features_i18n_title = /** @type {(inputs: Landing_Features_I18n_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internationalization`)
};

const zh_landing_features_i18n_title = /** @type {(inputs: Landing_Features_I18n_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国际化`)
};

/**
* | output |
* | --- |
* | "Internationalization" |
*
* @param {Landing_Features_I18n_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_i18n_title = /** @type {((inputs?: Landing_Features_I18n_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_I18n_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_i18n_title(inputs)
	return zh_landing_features_i18n_title(inputs)
});
export { landing_features_i18n_title as "landing.features.i18n.title" }